import React from 'react';
import {
  Input, Select,
} from 'antd';
import {
  Box, Text,
} from '../../shared/components';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';

export default function DatosDevolucion({
  onChangeUsuarioDevolucion, usuarios, mostrarDatosFinanciacion, onChangeFormaPago, formasPago,
  onChangeClienteFinanciador, onChangeNifClienteFinanciador, onChangeMesesAFinanciar,
}) {
  const { Option } = Select;
  let content = '';
  const usuariosArray = (typeof (usuarios) !== 'undefined') ? usuarios : [];
  const formasPagoArray = (typeof (formasPago) !== 'undefined') ? formasPago : [];

  content = (
    <Box>
      <TwoColumnsFlexLayout
        leftContent={(
          <Box mt="16">
            <Text fontSize="16"><b>Datos</b></Text>
          </Box>
        )}
      />

      <TwoColumnsFlexLayout
        leftContent={(
          <Box mt="16">
            <Box>
              <Text fontSize="14" mr="8" style={{ width: '266px', height: '24px' }}>Devuelto por...</Text>
            </Box>
            <Box>
              <Select
                // defaultValue="1"
                placeholder="Seleccione operador"
                style={{ width: '266px', height: '32px' }}
                onChange={onChangeUsuarioDevolucion}
              >
                {usuariosArray.map(item => (
                  <Option key={item.id} value={item.id}>{item.nombreCompleto}</Option>
                ))}
              </Select>
            </Box>
          </Box>
        )}
        rightContent={(
          <Box mt="16">
            <Box>
              <Text fontSize="14" ml="8" style={{ width: '266px', height: '24px' }}>Forma de pago</Text>
            </Box>
            <Box>
              <Select
                placeholder="Seleccione forma de pago"
                style={{ width: '266px', height: '32px', marginLeft: '8px' }}
                onChange={onChangeFormaPago}
              >
                {formasPagoArray.map(item => (
                  <Option key={item.id} value={item.id}>{item.descripcion}</Option>
                ))}
              </Select>
            </Box>
          </Box>
        )}
      />

      <ShowIf condition={mostrarDatosFinanciacion}>
        <TwoColumnsFlexLayout
          leftContent={(
            <Box mt="16">
              <Box>
                <Text fontSize="14" mr="8" style={{ width: '266px', height: '24px' }}>Cliente que financia</Text>
              </Box>
              <Box>
                <Input
                  placeholder="Cliente que financia"
                  style={{ width: '266px', height: '32px', marginRight: '8px' }}
                  onChange={onChangeClienteFinanciador}
                />
              </Box>
            </Box>
          )}
          rightContent={(
            <TwoColumnsFlexLayout
              leftContent={(
                <Box mt="16" ml="8">
                  <Text fontSize="14" style={{ width: '125px', height: '24px' }}>NIF</Text>
                  <Input
                    placeholder="NIF"
                    onChange={onChangeNifClienteFinanciador}
                  />
                </Box>
              )}
              rightContent={(
                <Box mt="16" ml="16">
                  <Text fontSize="14" style={{ width: '125px', height: '24px' }}>Meses</Text>
                  <Input
                    placeholder="Meses"
                    onChange={onChangeMesesAFinanciar}
                  />
                </Box>
              )}
            />
          )}
        />
      </ShowIf>
    </Box>

  );

  return content;
}
